import { useHistory, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { HiOutlineRefresh } from "react-icons/hi";
import AuditJournal from "../../components/audit/AuditJournal";
import { AUDIT_COLLECTION_LABELS } from "../../utils";

const AuditLog = ({ user }) => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { collectionName, documentId } = useParams();
  const collectionLabel = AUDIT_COLLECTION_LABELS[collectionName] || collectionName;

  return (
    <div className="min-h-[calc(100vh-60px)] bg-gray-50 p-6">
      <div className="mx-auto flex max-w-5xl flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex min-w-0 items-center gap-2 text-xl font-semibold text-gray-900">
            {collectionName ? (
              <button type="button" onClick={() => history.push("/audit-log")} className="shrink-0 text-gray-400 transition-colors hover:text-gray-700">
                Journal d&apos;audit
              </button>
            ) : (
              <h1>Journal d&apos;audit</h1>
            )}
            {collectionName && <span className="text-gray-300">/</span>}
            {collectionName &&
              (documentId ? (
                <button type="button" onClick={() => history.push(`/audit-log/${collectionName}`)} className="shrink-0 text-gray-400 transition-colors hover:text-gray-700">
                  {collectionLabel}
                </button>
              ) : (
                <h1>{collectionLabel}</h1>
              ))}
          </div>
          <button
            type="button"
            onClick={() => queryClient.invalidateQueries({ queryKey: ["audit-events"] })}
            className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50"
          >
            <HiOutlineRefresh className="h-4 w-4" />
            Actualiser
          </button>
        </div>

        <AuditJournal key={`${collectionName}/${documentId}`} collectionName={collectionName} documentId={documentId} user={user} />
      </div>
    </div>
  );
};

export default AuditLog;
